import { BaseResponse } from '../../../../../../types/api/api.types';
import { ENTITY_ENDPOINTS } from '../../../../../../utils/api/endpoints/entityEndpoints';
import { ProfileEntityFormSchema } from './ProfileEntityForm.types';

const PREFIX = '[createPendingEntityQuery]';

export const CREATE_PENDING_ENTITY_QUERY_KEY = 'CREATE_PENDING_ENTITY';

export const createPendingEntityQuery = async (data: ProfileEntityFormSchema) => {
  console.log(PREFIX, `Requesting user account update...`);

  const response = await ENTITY_ENDPOINTS.createPending(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received user account update response.`);
  return json as BaseResponse;
};
